import { useEffect, useState } from 'react'

export const useInitUtmMembrana = () => {
  const [isMembrana, setIsMembrana] = useState(false)

  useEffect(() => {
    if (window.location.search.includes('utm=membrana')) {
      setIsMembrana(true)
      sessionStorage.setItem('isMembrana', 'true')
    } else {
      const isMembranaFromStorage = sessionStorage.getItem('isMembrana')

      if (isMembranaFromStorage) {
        setIsMembrana(isMembranaFromStorage === 'true')
      }
    }
  }, [])

  return { isMembrana, setIsMembrana }
}
